import { z } from "zod";
import { toObjectMap } from "../utilities/dictionary";

const entityState = ["ACTIVE", "CREATED", "DRAFT", "REMOVED"] as const;
type EntityState = (typeof entityState)[number];
const entityStateMap = toObjectMap<EntityState>([...entityState]);

const entityStateZodSchema = z.enum(entityState);

export { entityState, entityStateMap, entityStateZodSchema };
export type { EntityState };
